import { Link } from "react-router-dom";
import { ArrowIcon, SparkIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL, PHONE_DISPLAY, PHONE_HREF } from "../site";

const whatWeOffer = [
  {
    number: "01",
    title: "Hair for the whole family",
    text: "Cutting, washing, and styling services for women, men, and children, plus perms, extensions by consultation, and special-occasion styling.",
    path: "/services/",
  },
  {
    number: "02",
    title: "Color and treatments",
    text: "Single-process color, partial, half, and full head foils, custom lightening, deep conditioning, and Keratin Complex treatments.",
    path: "/services/",
  },
  {
    number: "03",
    title: "Weddings and special events",
    text: "Hair and makeup for brides, wedding parties, and flower girls, in the salon or on location.",
    path: "/wedding/",
  },
  {
    number: "04",
    title: "Makeup and waxing",
    text: "Makeup services for every occasion alongside facial waxing for brows, lip, chin, sideburns, and full face.",
    path: "/make-up/",
  },
] as const;

export function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About us"
        title="A family salon in Englishtown."
        description="At Nadia’s Family Salon, we want you to look and feel your best. The perfect cut, color, or specialty hair treatment can make a difference in your look."
        image="/images/salon-hero.jpg"
      />

      <section className="section intro-section">
        <div className="container intro-grid">
          <div className="intro-copy">
            <p className="eyebrow">Who we are</p>
            <h2>Attentive hair, color, and beauty care in New Jersey.</h2>
            <p>Nadia’s Salon is a family salon at 14 Wilson Avenue, Suite 3 in Englishtown, New Jersey. Our professional team handles everyday haircuts and color as well as makeup, waxing, and special-event styling for weddings and other occasions.</p>
            <p>Every visit starts with listening. Consultations are free, so you can talk through a cut, a color change, or a specialty treatment before you commit to it. Appointments can be reserved online through our booking partner or by calling the salon.</p>
            <Link className="text-link" to="/staff/">Meet the people behind the chair <ArrowIcon /></Link>
          </div>
          <div className="intro-visual">
            <img className="intro-visual__large" src="/images/salon-detail-1.jpg" alt="The styling area inside Nadia's Salon" />
            <img className="intro-visual__small" src="/images/salon-detail-2.jpg" alt="An interior detail inside Nadia's Salon" />
            <div className="intro-note"><SparkIcon /><span>Free consultations,<br />never a rushed visit.</span></div>
          </div>
        </div>
      </section>

      <section className="section section--ink service-overview">
        <div className="container">
          <div className="section-heading section-heading--split">
            <div>
              <p className="eyebrow eyebrow--light">What we offer</p>
              <h2>One salon.<br />Every part of the look.</h2>
            </div>
            <p>Our service menu covers routine maintenance through event-day preparation, so the same team can follow your hair from a trim to a full color transformation to a wedding morning.</p>
          </div>
          <div className="featured-services">
            {whatWeOffer.map((item) => (
              <Link key={item.number} className="featured-service" to={item.path}>
                <span>{item.number}</span>
                <div><h3>{item.title}</h3><p>{item.text}</p></div>
                <ArrowIcon />
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section intro-section">
        <div className="container intro-grid">
          <div className="intro-copy">
            <p className="eyebrow">How we work</p>
            <h2>Professional skill. Personal attention.</h2>
            <p>Our stylists continue their education through manufacturer and brand programs, including Keratin Complex certification and advanced Paul Mitchell cutting and color training, and each one lists the specialties they focus on.</p>
            <p>Wedding and special-event work can happen in the salon or travel to you, and parties of six or more are hosted in the salon with champagne, orange juice, and hors d’oeuvres.</p>
            <Link className="text-link" to="/wedding/">See our wedding services <ArrowIcon /></Link>
          </div>
          <div className="intro-visual">
            <img className="intro-visual__large" src="/images/wedding-hair.jpg" alt="Special-occasion hair styling by Nadia's Salon" loading="lazy" decoding="async" />
            <img className="intro-visual__small" src="/images/gallery-3.jpg" alt="A finished hairstyle from the Nadia's Salon portfolio" loading="lazy" decoding="async" />
          </div>
        </div>
      </section>

      <section className="booking-banner">
        <div className="container booking-banner__inner">
          <div>
            <p className="eyebrow eyebrow--light">Your chair is waiting</p>
            <h2>Ready to visit Nadia’s Salon?</h2>
          </div>
          <div className="booking-banner__actions">
            <a className="button button--light" href={BOOKING_URL} target="_blank" rel="noreferrer">Book online <ArrowIcon /></a>
            <a className="text-link text-link--light" href={PHONE_HREF}>Or call {PHONE_DISPLAY}</a>
          </div>
        </div>
      </section>
    </>
  );
}
